import GenericLayout from 'components/GenericLayout'

function CommunityGuidelinesPage() {
  return (
    <GenericLayout>
      <div className="relative pb-32 overflow-hidden">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
          <div className="lg:grid lg:grid-cols-3 lg:gap-8">
            <div>
              <h2 className="text-3xl font-extrabold text-gray-900">
                {`Upstream's Community Guidelines`}
              </h2>
              <p className="mt-4 text-lg text-gray-500">
                {`We've outlined our guiding principles here. Have a question regarding our community guidelines? Reach out to our `}
                <a
                  href="mailto:sarah@upstreamapp.com"
                  className="font-medium text-blue-600 hover:text-blue-500"
                >
                  community team
                </a>
                .
              </p>
            </div>

            <div className="mt-12 lg:mt-0 lg:col-span-2">
              <dl className="space-y-12">
                <div>
                  <dt className="text-xl leading-6 font-medium text-gray-900">
                    {`What You Need to Know`}
                  </dt>
                  <dd className="mt-2 text-base text-gray-500 prose">
                    <p>
                      Community is the heart of Upstream. The success of a
                      community depends on the diversity of its members and
                      their ability to show up fully.
                    </p>

                    <p>We are committed to:</p>

                    <ul>
                      <li>Having no tolerance for discrimination, period.</li>
                      <li>Cultivating a culture that encourages generosity.</li>
                      <li>
                        Prioritizing high quality engagement and safety over
                        exponential growth.
                      </li>
                    </ul>

                    <p>
                      To read our full Community Guidelines and Values, please
                      see below.
                    </p>
                  </dd>
                </div>

                <div>
                  <dt className="text-xl leading-6 font-medium text-gray-900">
                    {`Our Full Community Guidelines`}
                  </dt>
                  <dd className="mt-2 text-base text-gray-500 prose">
                    <p>
                      Upstream is a community for professionals -- and we are
                      committed to building a space that does not simply mirror
                      existing IRL structures, but instead improves upon them.
                    </p>
                    <p>
                      We are committed to providing a space free from judgment,
                      fear, racism, sexism, homophobia, transphobia and all
                      forms of discrimination. We have a zero tolerance policy
                      against discrimination, period. This encompasses and
                      includes micro-aggressions, harassment, and disrespect.
                    </p>
                    <p>
                      In short, we expect our members to be professional, kind,
                      and respectful.
                    </p>
                    <p>
                      In return, we know that protecting the integrity of the
                      communities we host on Upstream is absolutely essential.
                      As a company, we prioritize delivering an amazing
                      experience for Upstream members over growing
                      exponentially.
                    </p>
                    <p>
                      We have chosen to grow at a measured pace and remain
                      hands-on with our community — so that we proactively build
                      the necessary community, moderation, accessibility, and
                      reporting features alongside our community. We celebrate
                      high quality engagement and safety.
                    </p>
                    <p>
                      In this spirit, we are grateful to be on this journey
                      together with our community and community admins. Our
                      community admins personally approve each membership
                      request to their communities. To preserve trust among
                      community members, we ask that you use a photo of your
                      face in your profile and your real name. In every
                      community, we do not allow spamming, disrespectful
                      engagement, or excessive pitching and empower our members
                      to report any violating incidents.
                    </p>
                    <p>
                      We empower our community members to be great allies and
                      stand up for those who may not be able to stand up for
                      themselves. Reporting can be conducted through our in-app
                      safety features and/or an email to
                      community@upstreamapp.com.
                    </p>
                    <p>
                      Any behavior that is reported or found to be out of
                      alignment with these community guidelines will be
                      investigated immediately and thoroughly, with appropriate
                      repercussions where necessary.
                    </p>
                    <p>
                      To deliver the best experience on Upstream for our
                      members, we reserve the right to remove community members
                      who are not acting in accordance with our community
                      guidelines and values.
                    </p>
                    <p>
                      As we continue to grow with our communities, we know these
                      community guidelines will evolve with us. We thank you for
                      joining us in on this delightful journey to build the #1
                      social place for professionals.
                    </p>
                  </dd>
                </div>

                <div>
                  <dt className="text-xl leading-6 font-medium text-gray-900">
                    {`Our Values`}
                  </dt>
                  <dd className="mt-2 text-base text-gray-500 prose">
                    <ul>
                      <li>
                        <b>Diversity</b> — There is nothing more important than
                        the diversity and safety of our community.{' '}
                      </li>

                      <li>
                        <b>Helpfulness</b> — Generosity is the core of what we
                        do.
                      </li>

                      <li>
                        <b>Trust</b> — Protect our members by upholding
                        community standards and prioritizing safety and
                        inclusion above all else.
                      </li>

                      <li>
                        <b>Delight</b> — Spark joy through experiences that are
                        simple and intuitive.
                      </li>

                      <li>
                        <b>Authenticity</b> — Cultivate a culture where our
                        community helps each other because they genuinely want
                        to, not in pursuit of something in return.
                      </li>

                      <li>
                        <b>Efficiency</b> — Make it possible for members to give
                        and get help as quickly as possible.
                      </li>
                    </ul>
                  </dd>
                </div>

                <div>
                  <dt className="text-xl leading-6 font-medium text-gray-900">
                    {`Our Promise`}
                  </dt>
                  <dd className="mt-2 text-base text-gray-500 prose">
                    <p>
                      We are a community-first company. We welcome your honest
                      feedback and full candor about every bit of your
                      experience on Upstream. Our inboxes, DMs, and phones are
                      always open to hear from you on how we can serve you
                      better.
                    </p>

                    <p>
                      We are grateful for your input on these community
                      guidelines and values. Drop us a line directly {`to `}
                      <a href="mailto:alex@upstreamapp.com">Alex</a>
                      {` or `}
                      <a href="mailto:sarah@upstreamapp.com">Sarah</a>, or email{' '}
                      <a href="mailto:hi@upstreamapp.com">hi@upstreamapp.com</a>
                      .
                    </p>

                    <p>
                      We imagine a not-so distant future when Upstream is your
                      most powerful tool for building connections, cultivating
                      communities, and transforming your life as you know it
                      through your network. Thank you for helping us build this
                      future.
                    </p>

                    <p>
                      With gratitude,
                      <br />
                      <span className="text-blue">The Upstream Team</span>
                    </p>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </GenericLayout>
  )
}

export default CommunityGuidelinesPage
